import { TextField } from "@material-ui/core";

interface TextFieldDEProps {
	value: string;
	label?: string;
	disabled?: boolean;
	onChange: (value: string) => void;
	onBlur: (value: string) => void;
	pause: () => void;
	resume: () => void;
}

export const TextFieldDE = ({
	value,
	label,
	onChange,
	onBlur,
	disabled = false,
	pause,
	resume,
}: TextFieldDEProps) => {
	const onFocus = () => {
		pause();
	};

	return (
		<TextField
			fullWidth
			disabled={disabled}
			label={label}
			variant={"outlined"}
			value={value || ""}
			onFocus={onFocus}
			onChange={(e) => {
				onChange(e.target.value);
			}}
			onKeyDown={(e) => {
				if (e.key === "Enter") {
					resume();
					onBlur(value);
				}
			}}
			onBlur={() => {
				resume();
				onBlur(value);
			}}
			style={{
				minWidth: "50px",
			}}
		/>
	);
};
